import { render, staticRenderFns } from "./ImagesManagementReview.vue?vue&type=template&id=4d72b746&scoped=true&"
import script from "./ImagesManagementReview.vue?vue&type=script&lang=js&"
export * from "./ImagesManagementReview.vue?vue&type=script&lang=js&"
import style0 from "./ImagesManagementReview.vue?vue&type=style&index=0&id=4d72b746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72b746",
  null
  
)

export default component.exports